export enum SystemModulesEnum {
  // // // ADMIN ============================
  // ACTIVACIONES_RAD_CHECK = 'ACTIVACIONES.RAD_CHECK',
  ADMIN_PAISES = 'ADMIN.PAISES',
  ADMIN_PROVINCIAS = 'ADMIN.PROVINCIAS',
  ADMIN_CIUDADES = 'ADMIN.CIUDADES',
  ADMIN_IVA = 'ADMIN.IVA',
  ADMIN_EMPRESAS = 'ADMIN.EMPRESAS',
  ADMIN_METODO_PAGO = 'ADMIN.METODO_PAGO',
  ADMIN_METODO_PAGO_PROVEEDOR = 'ADMIN.METODO_PAGO_PROVEEDOR',
  ADMIN_PROMOCIONES = 'ADMIN.PROMOCIONES',
  ADMIN_TIPO_INSTALACION = 'ADMIN.TIPO_INSTALACION',
  ADMIN_TIPO_COMPROBANTE = 'ADMIN.TIPO_COMPROBANTE',
  ADMIN_AREAS = 'ADMIN.AREAS',
  ADMIN_OBSERVACION = 'ADMIN.OBSERVACION',
  ADMIN_RESPONSABLE = 'ADMIN.RESPONSABLE',

  ADMIN_TIPO_REGIMEN = 'ADMIN.TIPO_REGIMEN',
  ADMIN_CODIGOS_OTP = 'ADMIN.CODIGOS_OTP',
  ADMIN_DEPARTAMENTOS = 'ADMIN.DEPARTAMENTOS',
  ADMIN_ENTIDADES_FINANCIERAS = 'ADMIN.ENTIDADES_FINANCIERAS',
  ADMIN_COOPERATIVAS = 'ADMIN.COOPERATIVAS',
  ADMIN_CANALES_VENTA = 'ADMIN.CANALES_VENTA',
  ADMIN_COMICIONES_CONFIGURACION = 'ADMIN.COMICIONES_CONFIGURACION',
  ADMIN_TARJETAS = 'ADMIN.TARJETAS',
  ADMIN_MOTIVO_RECHAZO = 'ADMIN.MOTIVO_RECHAZO',
  ADMIN_MOTIVO = 'ADMIN.MOTIVO',
  ADMIN_CONFIGURACION_PLANTIALLA = 'ADMIN.CONFIGURACION_PLANTIALLA',
  ADMIN_CENTRO_COSTO = 'ADMIN.CENTRO_COSTO',
  ADMIN_UNIDADES_TRANSPORTE = 'ADMIN.UNIDADES_TRANSPORTE',
  ADMIN_ICE = 'ADMIN.ICE',
  ADMIN_PORCENTAJE_RET_IVA_BIENES = 'ADMIN.PORCENTAJE_RET_IVA_BIENES',
  ADMIN_PORCENTAJE_RET_IVA_SERVICIOS = 'ADMIN.PORCENTAJE_RET_IVA_SERVICIOS',
  ADMIN_PARAMETRO = 'ADMIN.PARAMETRO',
  ADMIN_AUDITORIA = 'ADMIN.AUDITORIA',
  ADMIN_RECEPCION_EQUIPOS_CATALOGOS = 'ADMIN.RECEPCION_EQUIPOS_CATALOGOS',

  // // // MANTENIMIENTO ============================
  MANTENIMIENTO_ZONAS = 'MANTENIMIENTO.ZONAS',
  MANTENIMIENTO_SECTORES = 'MANTENIMIENTO.SECTORES',
  MANTENIMIENTO_NODOS = 'MANTENIMIENTO.NODOS',
  MANTENIMIENTO_RADIO_BASE = 'MANTENIMIENTO.RADIO_BASE',
  MANTENIMIENTO_NAP = 'MANTENIMIENTO.NAP',
  MANTENIMIENTO_PLANIFICADOR = 'MANTENIMIENTO.PLANIFICADOR',
  MANTEMIENTO_FLOTAS = 'MANTENIMIENTO.FLOTAS',
  MANTEMIENTO_PENDIENTE_ACTUALIZAR = 'MANTENIMIENTO.PENDIENTE_ACTUALIZAR',
  MANTEMIENTO_RECHAZADAS_TECNICO = 'MANTENIMIENTO.RECHAZADAS_TECNICO',
  MANTEMIENTO_INSTALACIONES_TECNICOS = 'MANTENIMIENTO.INSTALACIONES_TECNICOS',

  // // // VENTAS ============================
  VENTAS_PROSPECTOS = 'VENTAS.PROSPECTOS',
  VENTAS_PREVENTAS = 'VENTAS.PREVENTAS',
  VENTAS_PREAGENDAMIENTOS = 'VENTAS.PREAGENDAMIENTOS',
  VENTAS_RECHAZADO_VENTAS = 'VENTAS.PRE_RECHAZADO_VENTAS',
  VENTAS_PENDIENTE_ACTUALIZAR = 'VENTAS.PENDIENTE_ACTUALIZAR',
  VENTAS_PREAGENDAMIENTOS_RECHAZADO = 'VENTAS.PREAGENDAMIENTOS.RECHAZADO',
  VENTAS_PENDIENTE_AUTORIZACION = 'VENTAS.PENDIENTE_AUTORIZACION',
  VENTAS_AGENDADAS = 'VENTAS.AGENDADAS',
  VENTAS_INFORME_INSTALACION_PROGRAMADAS = 'VENTAS.INFORME_INSTALACION_PROGRAMADAS',
  VENTAS_REFERIDO = 'VENTAS.REFERIDO',
  VENTAS_INSTALACIONES_ASIGNADAS = 'VENTAS.INSTALACIONES.ASIGNADAS',
  VENTAS_INSTALACIONES_REALIZADAS = 'VENTAS.INSTALACIONES.REALIZADAS',
  VENTAS_BITACORA = 'VENTAS.BITACORA',
  HISTORIAL_VENTAS = 'VENTAS.HISTORIAL_VENTAS',
  // // // VENTAS PYME ========================
  VENTAS_PYMES_PROSPECTOS = 'VENTAS_PYMES.PROSPECTOS',
  VENTAS_PYMES_PREVENTAS = 'VENTAS_PYMES.PREVENTAS',
  VENTAS_PYMES_PREAGENDAMIENTOS = 'VENTAS_PYMES.PREAGENDAMIENTOS',
  VENTAS_PYMES_AGENDAMIENTO = 'VENTAS_PYMES.AGENDADAS',
  VENTAS_PYMES_GESTION_VENTA = 'VENTAS_PYMES.GESTION_VENTA',
  // // // SUPERVISION PYMES ============================
  SUPERVISION_PYMES_SOLICITUD_CONTRATO_FISICO = 'SUPERVISOR_PYMES.SOLICITUD_CONTRATO_FISICO',

  // // // SOPORTE PYMES ============================

  SOPORTE_PYMES_AGENDAMIENTO = 'SOPORTE_PYMES.AGENDAMIENTO',
  INVENTARIO_ORDEN_JEFE_COMPRA = 'INVENTARIO_ORDEN_JEFE_COMPRA',
  //SERVICIOS
  SERVICIOS_INTERNET = 'SERVICIOS.INTERNET',
  // // // SUPERVISION_VENTAS ============================
  SUPERVISION_VENTAS_SOLICITUD_LIBERACION = 'SUPERVISION_VENTAS.SOLICITUD_LIBERACION',
  SUPERVISION_VENTAS_SOLICITUD_LIBERACION_PROSPECTO = 'SUPERVISION_VENTAS.SOLICITUD_LIBERACION_PROSPECTO',
  SUPERVISION_VENTAS_SOLICITUD_CONTRATO_FISICO = 'SUPERVISION_VENTAS.SOLICITUD_CONTRATO_FISICO',
  SUPERVISION_VENTAS_PROSPECTO = 'SUPERVISION_VENTAS.PROSPECTO',
  SUPERVISION_VENTAS_PREVENTA = 'SUPERVISION_VENTAS.PREVENTA',
  SUPERVISION_VENTAS_PREAGENDAMIENTOS = 'SUPERVISION_VENTAS.PREAGENDAMIENTOS',
  //SUPERVISION_VENTAS_RECHAZADO = 'SUPERVISION_VENTAS.PREAGENDAMIENTO.RECHAZADO',
  SUPERVISION_VENTAS_RECHAZADO = 'SUPERVISION_VENTAS.RECHAZADO',
  SUPERVISION_VENTAS_SOLICITUD_INGRESO_PROSPECTO = 'SUPERVISION_VENTAS.SOLICITUD_INGRESO_PROSPECTO',
  SUPERVISION_VENTAS_SOLICITUD_LIBERACION_VALOR_INSTALACION = 'SUPERVISION_VENTAS.SOLICITUD_LIBERACION_VALOR_INSTALACION',
  SUPERVISION_VENTAS_VERIFICAR_CONTRATO_INSTALACION = 'SUPERVISION_VENTAS.VERIFICAR_CONTRATO_INSTALACION',
  SUPERVISION_VENTAS_CODIGO_OTP_SOLICITUD_APROBACION = 'SUPERVISION_VENTAS.CODIGO_OTP.SOLICITUD_APROBACION',
  SUPERVISION_VENTAS_CLIENTES_FIBRA_OPTICA = 'SUPERVISION_VENTAS.CLIENTES_FIBRA_OPTICA',
  SUPERVISION_VENTAS_SOLICITUD_PASAR_DEUDA = 'SUPERVISION_VENTAS.SOLICITUD_PASAR_DEUDA',
  SUPERVISION_VENTAS_SOLICITUD_VENTA_EXTRANJERO = 'SUPERVISION_VENTAS.SOLICITUD_VENTA_EXTRANJERO',
  SUPERVISION_VENTAS_SOLICITUD_GREMIO = 'SUPERVISION_VENTAS.SOLICITUD_VENTA_GREMIO',
  SUPERVISION_VENTAS_BITACORA = 'SUPERVISION_VENTAS.BITACORA',
  SUPERVISION_VENTAS_INSTALACION_PROGRAMADAS = 'SUPERVISION_VENTAS.INFORME_INSTALACION_PROGRAMADAS',
  SUPERVISION_VENTAS_SEGUIMIENTO_ACTIVIDADES = 'SUPERVISION_VENTAS.SEGUIMIENTO_ACTIVIDADES',

  // // // OPERACIONES ============================
  OPERACIONES_PLANEACION_AGENDAMIENTOS = 'OPERACIONES.PLANEACION.AGENDAMIENTOS',
  OPERACIONES_PLANEACION_AGENDAMIENTOS_FINALIZADOS = 'OPERACIONES.PLANEACION.AGENDAMIENTOS.FINALIZADOS',
  OPERACIONES_TECNICO_INSTALACIONES = 'OPERACIONES.TECNICO.INSTALACIONES',
  OPERACIONES_BITACORA = 'OPERACIONES.BITACORA',
  OPERACIONES_AGENDA = 'OPERACIONES.AGENDA',
  OPERACIONES_INFORME_INSTALACION_PROGRAMADAS = 'OPERACIONES.INFORME_INSTALACION_PROGRAMADAS',
  OPERACIONES_RECHAZADAS_TECNICO = 'OPERACIONES.RECHAZADAS_TECNICO',

  // ACTIVACIONES ------
  // inicialmente estaban dentro de operaciones
  OPERACIONES_SEGUIMIENTO_ACTIVIDADES = 'OPERACIONES.SEGUIMIENTO_ACTIVIDADES',

  // ACTIVACION ------
  OPERACIONES_ACTIVACION_INSTALACIONES_INSTALACIONES = 'OPERACIONES.ACTIVACION.INSTALACIONES.INSTALACIONES',
  OPERACIONES_ACTIVACION_INSTALACIONES_FOTOS = 'OPERACIONES.ACTIVACION.INSTALACIONES.FOTOS',
  OPERACIONES_ACTIVACION_INSTALACIONES_CAMBIO_PUERTO = 'OPERACIONES.ACTIVACION.INSTALACIONES.CAMBIO_PUERTO',
  // nuevos módulos
  ACTIVACIONES_RECHAZADAS_TECNICO = "ACTIVACIONES.RECHAZADAS_TECNICO",
  ACTIVACIONES_CAJAS_PUERTOS_DISPONIBLES = "ACTIVACIONES.CAJAS_PUERTOS_DISPONIBLES",
  ACTIVACIONES_ACTUALIZACION_SERVICIO_CLIENTES = "ACTIVACIONES.ACTUALIZACION_SERVICIO_CLIENTES",
  ACTIVACIONES_RAD_CHECK = "ACTIVACIONES.RAD_CHECK",
  ACTIVACIONES_VISITA = "ACTIVACIONES.VISITA",
  ACTIVACIONES_TRASLADO = "ACTIVACIONES.TRASLADO",
  ACTIVACIONES_CONSULTAS = "ACTIVACIONES.CONSULTAS",

  // // // AUDITORIA ----------------
  OPERACIONES_AUDITORIA_INSTALACIONES = 'OPERACIONES.AUDITORIA.INSTALACIONES',

  // // // CONFIGURACION_RED ============================
  CONFIGURACION_RED_GRUPO_IPV4 = 'CONFIGURACION_RED.GRUPO_IPV4',
  CONFIGURACION_RED_GRUPO_IPV6 = 'CONFIGURACION_RED.GRUPO_IPV6',
  CONFIGURACION_RED_IPV4 = 'CONFIGURACION_RED.IPV4',
  CONFIGURACION_RED_OLT = 'CONFIGURACION_RED.OLT',
  CONFIGURACION_RED_NODOS = 'CONFIGURACION_RED.NODOS',
  CONFIGURACION_RED_CAJA_PRIMARIA = 'CONFIGURACION_RED.CAJA_PRIMARIA',
  CONFIGURACION_RED_CAJA_SECUNDARIA = 'CONFIGURACION_RED.CAJA_SECUNDARIA',
  CONFIGURACION_RED_BRAS = 'CONFIGURACION_RED.BRAS',
  CONFIGURACION_RED_RADIUS = 'CONFIGURACION_RED.RADIUS',
  CONFIGURACION_RED_ROUTERS = 'CONFIGURACION_RED.ROUTERS',
  CONFIGURACION_RED_OPERADORA = 'CONFIGURACION_RED.OPERADORA',
  CONFIGURACION_RED_RADIUS_MIGRACIONES = 'CONFIGURACION_RED.RADIUS_MIGRACIONES',
  CONFIGURACION_RED_SERVICE_PROFILE = 'CONFIGURACION_RED.SERVICE_PROFILE',

  // // // TECNICO ============================
  TECNICO_INSTALACIONES_INSTALACIONES = 'TECNICO.INSTALACIONES.INSTALACIONES',
  TECNICO_INSTALACIONES_FOTOS = 'TECNICO.INSTALACIONES.FOTOS',
  TECNICO_VISITAS = 'TECNICO.VISITAS',
  TECNICO_RETIROS = 'TECNICO.RETIROS',
  TECNICO_TRASLADOS = 'TECNICO.TRASLADOS',
  TECNICO_MIGRACIONES = 'TECNICO.MIGRACIONES',
  TECNICO_ORDENES_TRABAJO_NOC = 'TECNICO.ORDENES_TRABAJO_NOC',
  TECNICO_DETALLE_DE_MATERIALES = 'TECNICO.DETALLEMATERIALES',
  TECNICO_SERVICIO_CORPORATIVO = "TECNICO.SERVICIO_CORPORATIVO",
  TECNICO_ATS = 'TECNICO.ATS',
  TECNICO_NOTIFICACION_INVENTARIO = 'TECNICO.NOTIFICACION_INVENTARIO',
  TECNICO_CONSULTAS_NAPS = 'TECNICO.CONSULTAS_NAPS',

  // // // CLIENTES ============================
  CLIENTES_CLIENTES_CONTRATO = 'CLIENTES.CLIENTES_CONTRATO',
  CLIENTES_CLIENTES_FIBRA = 'CLIENTES.CLIENTES_FIBRA',
  CLIENTES_CLIENTES_WIRELESS = 'CLIENTES.CLIENTES_WIRELESS',
  CLIENTES_CLIENTES_COORPORATIVOS = 'CLIENTES.CLIENTES_COORPORATIVOS',
  CLIENTES_CLIENTES_ISP = 'CLIENTES.CLIENTES_ISP',
  CLIENTES_CLIENTES_BRAS = 'CLIENTES.CLIENTES_BRAS',

  // // // USUARIOS ----------------
  USUARIOS_USUARIOS = 'USUARIOS.USUARIOS',
  USUARIOS_GRUPOS = 'USUARIOS.GRUPOS',
  USUARIOS_MFA_ADMIN = 'USUARIOS.MFA_ADMIN',
  USUARIOS_REPORTE_USUARIOS = 'USUARIOS.REPORTE_USUARIOS',

  // // // INVENTARIO ============================
  INVENTARIO_CATEGORIA_PRODUCTO = 'INVENTARIO.CATEGORIA_PRODUCTO',
  INVENTARIO_SUBCATEGORIA_PRODUCTO = 'INVENTARIO.SUBCATEGORIA_PRODUCTO',
  INVENTARIO_UBICACIONES = 'INVENTARIO.UBICACIONES',
  INVENTARIO_BODEGAS = 'INVENTARIO.BODEGAS',
  INVENTARIO_INGRESO_INVENTARIO = 'INVENTARIO.INGRESO_INVENTARIO',
  INVENTARIO_SOLICITUD_INVENTARIO = 'INVENTARIO.SOLICITUD_INVENTARIO',
  INVENTARIO_REVISAR_SOLICITUD_INVENTARIO = 'INVENTARIO.REVISAR_SOLICITUD_INVENTARIO',
  INVENTARIO_REVISAR_SOLICITUD_PEDIDO = 'INVENTARIO.REVISAR_SOLICITUD_PEDIDO',
  INVENTARIO_TRASLADO_INVENTARIO = 'INVENTARIO.TRASLADO_INVENTARIO',
  INVENTARIO_SOLICITUDES_PEDIDO = 'INVENTARIO.SOLICITUDES_PEDIDO',
  INVENTARIO_REPORTE_STOCK = 'INVENTARIO.REPORTESTOCK',
  INVENTARIO_CUADRE_INVENTARIO = 'INVENTARIO.CUADRE_INVENTARIO',
  INVENTARIO_RECEPCION_TRANSFERENCIA = 'INVENTARIO.RECEPCION_TRANSFERENCIA',

  // INVENTARIO_SOLICITUDES_DESPACHAR = 'INVENTARIO.SOLICITUDES_DESPACHAR',

  INVENTARIO_MODELO_PRODUCTO = 'INVENTARIO.MODELO_PRODUCTO',
  INVENTARIO_MARCA_PRODUCTO = 'INVENTARIO.MARCA_PRODUCTO',
  //INVENTARIO_SOLICITUD_INGRESO = 'INVENTARIO.SOLICITUD_INGRESO',
  INVENTARIO_GASTOS = 'INVENTARIO.GASTOS',



  // Kit inventariable

  INVENTARIO_PRODUCTO = 'INVENTARIO.PRODUCTO',
  INVENTARIO_INGRESO = 'INVENTARIO.INGRESO',
  INVENTARIO_EGRESOS = 'INVENTARIO.EGRESOS',
  INVENTARIO_TOMA_FISICA = 'INVENTARIO.TOMA_FISICA',

  INVENTARIO_SOLICITUD_FACTIBILIDAD_CORPORATIVA = 'INVENTARIO.SOLICITUD_FACTIBILIDAD_CORPORATIVA',
  ///ingrso
  //INVENTARIO_INGRESOS_CREAR = 'COMPRAS.PROVEEDORES',
  ///recpcion
  //INVENTARIO_ORDEN_COMPRA = 'COMPRAS.ORDEN_COMPRA',
  //*SOLICITUD DE COMPRA/INGRESO
  INVENTARIO_SOLICITUD_INGRESO_COMPRA = 'INVENTARIO.SOLICITUD_INGRESO_COMPRA',
  INVENTARIO_RECEPCION_MERCADERIA = 'INVENTARIO.RECEPCION_MERCADERIA',
  INVENTARIO_ORDEN_COMPRA = 'COMPRAS.ORDEN_COMPRA',
  //// // PEDIDOS
  //PEDIDOS_SOLICITUD_PEDIDO = 'COMPRAS.SOLICITUD_PEDIDO',
  PEDIDOS_SOLICITUD_PEDIDO = 'PEDIDOS.SOLICITUD_PEDIDO',


  // // // COMPRAS ----------------

  COMPRAS_PROVEEDORES = 'COMPRAS.PROVEEDORES',
  COMPRAS_SOLICITUD_PEDIDO = 'COMPRAS.SOLICITUD_PEDIDO',
  COMPRAS_INGRESOS = 'COMPRAS.INGRESOS',
  COMPRAS_COMPRAS = 'COMPRAS.COMPRAS',
  COMPRAS_ORDEN_COMPRA = 'COMPRAS.ORDEN_COMPRA',
  ///COMPRAS_COMPRAS = 'COMPRAS.COMPRAS',
  COMPRAS_RETENCIONES = 'COMPRAS.RETENCIONES',
  //******
  COMPRAS_ORDEN_COMPRA_CONSULTAS = 'COMPRAS.ORDEN_COMPRA_CONSULTAS',
  REPORTE_COMPRA = 'COMPRAS.REPORTE',
  //COMPRAS_ORDEN_JEFE_COMPRA = 'INVENTARIO.ORDEN_JEFE_COMPRA',
  // // // ACTIVOS ----------------
  ACTIVOS_ACTIVOS = 'ACTIVOS.ACTIVOS',
  ACTIVOS_GRUPO_ACTIVOS = 'ACTIVOS.GRUPO_ACTIVOS',
  ACTIVOS_ASIGNACION_ACTIVOS = 'ACTIVOS.ASIGNACION_ACTIVOS',
  ACTIVOS_MANTENIMIENTO_ACTIVOS = 'ACTIVOS.MANTENIMIENTO_ACTIVOS',
  // // // CONTABILIDAD ----------------|
  CONTABILIDAD_REGISTRO_FACTURA = 'CONTABILIDAD.REGISTRO_FACTURA',
  CONTABILIDAD_COMPROBANTE_PAGO_INSTALACION = 'CONTABILIDAD.COMPROBANTE_PAGO_INSTALACION',
  CONTABILIDAD_PLAN_DE_CUENTAS = 'CONTABILIDAD.PLAN_DE_CUENTAS',
  CONTABILIDAD_CLIENTES_COORPORATIVOS = 'CONTABILIDAD.CLIENTES_COORPORATIVOS',
  CONTABILIDAD_REINGRESO_SERIE = 'CONTABILIDAD.REINGRESO_SERIE',
  CONTABILIDAD_GESTION_INVENTARIO_CUADRE = 'CONTABILIDAD.GESTION_INVENTARIO_CUADRE',

  // // // SOPORTE TECNICO ----------------
  SOPORTE_TECNICO_DESBLOQUEO_USUARIOS = 'SOPORTE_TECNICO.DESBLOQUEO_USUARIO',

  // // // TICKETS SOPORTE ----------------
  NUEVO_TICKET_TICKETS_CLIENTES = 'TICKETS_SOPORTE_CLIENTES.NUEVO_TICKET',
  CATEGORIA_TICKETS_CLIENTES = 'TICKETS_SOPORTE_CLIENTES.CATEGORIA_INCIDENTE',
  SUBCATEGORIA_TICKETS_CLIENTES = 'TICKETS_SOPORTE_CLIENTES.SUBCATEGORIA_INCIDENTE',
  CAUSAL_TICKETS_CLIENTES = 'TICKETS_SOPORTE_CLIENTES.CAUSAL_INCIDENTE',
  MIS_TICKETS = 'TICKETS_SOPORTE_CLIENTES.MIS_TICKETS',
  TICKETS_DEPARTAMENTO = 'TICKETS_SOPORTE_CLIENTES.TICKETS_DEPARTAMENTO',
  TICKETS_MASIVOS = 'TICKETS_SOPORTE_CLIENTES.MASIVOS',
  TICKETS_AGENDA_TECNICOS = 'TICKETS_SOPORTE_CLIENTES.AGENDA_TECNICOS',
  TICKETS_CATALOGOS = 'TICKETS_SOPORTE_CLIENTES.CATALOGOS',
  GESTION_ACCESOS = 'TICKETS_SOPORTE_CLIENTES.GESTION_ACCESOS',
  TICKETS_INTERNOS = 'TICKETS_SOPORTE_CLIENTES.TICKETS_INTERNOS',

  // // // CAMPAÑAS (migración / fidelización) ----------------
  CAMPANAS_CAMPANAS = 'CAMPANAS.CAMPANAS',
  CAMPANAS_COBRANZAS = 'CAMPANAS.COBRANZAS',
  CAMPANAS_FIRMA_ADENDUM = 'CAMPANAS.FIRMA_ADENDUM',
  CAMPANAS_FIDELIZACION = 'CAMPANAS.FIDELIZACION',
  /////VSISTAS
  TICKETS_PENDIENTES_ASIGNACION = 'VISITAS.TICKETS_PENDIENTES_ASIGNACION',
  VISITAS_AGENDA_DIARIA = 'VISITAS.AGENDA_DIARIA',
  VISITAS_REQUIERE_VISITA = 'VISITAS.REQUIERE_VISITA',
  VISITAS_FINALIZADAS = 'VISITAS.FINALIZADAS',

  // // // CATÁLOGOS DE TICKETS (tabs de /tickets-soporte-cliente/catalogos) --------
  CATALOGOS_ESTADOS = 'TICKETS_CATALOGOS.ESTADOS',
  CATALOGOS_PRIORIDADES = 'TICKETS_CATALOGOS.PRIORIDADES',
  CATALOGOS_AREAS = 'TICKETS_CATALOGOS.AREAS',
  CATALOGOS_CANALES = 'TICKETS_CATALOGOS.CANALES',
  CATALOGOS_TIPOS = 'TICKETS_CATALOGOS.TIPOS',
  CATALOGOS_CATEGORIAS = 'TICKETS_CATALOGOS.CATEGORIAS',
  CATALOGOS_SUBCATEGORIAS = 'TICKETS_CATALOGOS.SUBCATEGORIAS',
  CATALOGOS_ARBOL_CIERRE = 'TICKETS_CATALOGOS.ARBOL_CIERRE',
  CATALOGOS_CONFIGURACION_ARBOL = 'TICKETS_CATALOGOS.CONFIGURACION_ARBOL',
  CATALOGOS_ADMINISTRACION = 'TICKETS_CATALOGOS.ADMINISTRACION',
  // Sub-tabs dentro del tab "Administración" de catálogos.
  CATALOGOS_ADMINISTRACION_VISITAS = 'TICKETS_CATALOGOS.ADMINISTRACION_VISITAS',
  CATALOGOS_ADMINISTRACION_TRASLADOS = 'TICKETS_CATALOGOS.ADMINISTRACION_TRASLADOS',

  // Traslados: tab "Finalizados" (timeline completo) + vista general de OS
  OPERACIONES_TRASLADOS_FINALIZADOS = 'OPERACIONES.TRASLADOS_FINALIZADOS',
  OPERACIONES_ORDENES_SERVICIO_GENERAL = 'OPERACIONES.ORDENES_SERVICIO_GENERAL',
  // NOTA: la supervisión de traslados (Editar/Auditoría) NO usa Módulos del
  // Sistema; se gestiona por Roles/permisos RBAC del tickets-service
  // (operaciones.editar_traslado_supervision / operaciones.ver_auditoria_traslado).

  // TODO: delete this
  TECNICO_NO = 'TECNICO.NO',
  //NOMINA
  NOMINA_CARGOS = 'NOMINA.CARGOS',
  NOMINA_EMPLEADOS = 'NOMINA.EMPLEADOS',
  //tickets users
  SOPORTE_TECNICO_TIKETS_USUARIOS = 'SOPORTE_TECNICO.TIKETS_USUARIOS',
  SOPORTE_TECNICO_TIKETS_USUARIOS_REVISAR = 'SOPORTE_TECNICO.TIKETS_USUARIOS_REVISAR',

  // // // CATALOGO PRODUCTO ============================
  CATALOGO_PRODUCTO_INVENTARIABLES = 'CATALOGO_PRODUCTO.INVENTARIABLES',
  CATALOGO_PRODUCTO_COSTOS = 'CATALOGO_PRODUCTO.COSTOS',
  CATALOGO_PRODUCTO_GASTOS = 'CATALOGO_PRODUCTO.GASTOS',
  CATALOGO_PRODUCTO_SERVICIOS = 'CATALOGO_PRODUCTO.SERVICIOS',
  CATALOGO_PRODUCTO_ACTIVOS = 'CATALOGO_PRODUCTO.ACTIVOS',
  CATALOGO_PRODUCTO_VENTAS = 'CATALOGO_PRODUCTO.VENTAS',

  // // // CONFIGURACION INVETARIO ============================
  CONFIGURACION_INVENTARIO_UNIDA_MEDIDA = 'CONFIGURACION_INVENTARIO.UNIDA_MEDIDA',
  CONFIGURACION_INVENTARIO_PRESENTACION = 'CONFIGURACION_INVENTARIO.PRESENTACION',
  CONFIGURACION_INVENTARIO_CATEGORIA = 'CONFIGURACION_INVENTARIO.CATEGORIA',
  CONFIGURACION_INVENTARIO_SUBCATEGORIA = 'CONFIGURACION_INVENTARIO.SUBCATEGORIA',
  CONFIGURACION_INVENTARIO_GENERADOR_SERIES = 'CONFIGURACION_INVENTARIO.GENERADOR_SERIES',
  CONFIGURACION_INVENTARIO_CONFIGURACION_TRANSITO = 'CONFIGURACION_INVENTARIO.CONFIGURACION_TRANSITO',

  // // // DOCUMENTACION ============================
  DOCUMENTACION_KARDEX = 'DOCUMENTACION.KARDEX',
  DOCUMENTACION_INVENTARIABLE = 'DOCUMENTACION.INVENTARIABLE',

  // // // RECAUDACIONES | TRANSACCIONES  ============================
  RECAUDACIONES_RUBROS = 'RECAUDACIONES.RUBROS',
  RECAUDACIONES_SALDOS = 'RECAUDACIONES.SALDOS',
  RECAUDACIONES_TRANSACCIONES = 'RECAUDACIONES.TRANSACCIONES',

  // // // CORPORATIVOS ============================
  SOLICITUDES_PENDIENTES_CORPORATIVOS = 'SCORPORATIVOS.SOLICITUDES_PENDIENTES_CORPORATIVOS',
  SOLICITUDES_CAPACIDAD_CORPORATIVOS = 'SCORPORATIVOS.SOLICITUDES_CAPACIDAD_CORPORATIVOS',
  PLANES_CORPORATIVOS = 'SCORPORATIVOS.PLANES_CORPORATIVOS',
  // // // VENTAS ============================
  VENTAS_PROSPECTOS_CORPORATIVOS = 'VENTAS.PROSPECTOS_CORPORATIVOS',
  VENTAS_PREVENTAS_CORPORATIVOS = 'VENTAS.PREVENTAS_CORPORATIVOS',
  VENTAS_SOLUCION_COSTEADA_CORPORATIVOS = 'VENTAS.SOLUCION_COSTEADA_CORPORATIVOS',
  VENTAS_ESTADO_VENTA_CORPORATIVOS = 'VENTAS.ESTADO_VENTA_CORPORATIVOS',
  VENTAS_SEGUIMIENTO_COSTE_CORPORATIVOS = 'VENTAS.SEGUIMIENTO_COSTE_CORPORATIVOS',
  VENTAS_COBERTURA_CORPORATIVA = 'VENTAS.COBERTURA_CORPORATIVA',
  VENTAS_COBERTURA_NAPS = 'VENTAS.COBERTURA_NAPS',
  // // // INGRESOS ============================

  ///* kit
  // INVENTARIO_KIT = 'INVENTARIO.KITINVENTARIO',


  VENTAS_GESTION_OPORTUNIDAD_COMERCIAL = 'VENTAS.GESTION_OPORTUNIDAD_COMERCIAL',
  VENTAS_OPORTUNIDAD_COMERCIAL_DEMO = 'VENTAS.OPORTUNIDAD_COMERCIAL_DEMO',
  // // // NOC ============================
  NOC_FACTIBILIDAD_CORPORATIVOS = 'NOC.FACTIBILIDAD_CORPORATIVOS',
  NOC_GESTION_FACTIBILIDAD_CORPORATIVOS = 'NOC.GESTION_FACTIBILIDAD_CORPORATIVOS',
  NOC_INSPECCION_FACTIBILIDAD_CORPORATIVOS = 'NOC.INSPECCION_FACTIBILIDAD_CORPORATIVOS',
  NOC_AGENDAMIENTO = 'NOC.AGENDAMIENTOS',
  NOC_SOLICITUD_TECNICO = 'NOC.SOLICITUD_TECNICO',
  NOC_ORDENES_DE_TRABAJO = 'NOC.ORDENES_DE_TRABAJO',
  NOC_PARAMETROS_ORDENES_DE_TRABAJO = 'NOC.PARAMETROS_ORDENES_DE_TRABAJO',

  //Solicitudes
  NOC_SOLICITUD_CORPORATIVO = "NOC.SOLICITUD_CORPORATIVO",
  NOC_SOLICITUD_SUCURSAL = "NOC.SOLICITUD_SUCURSAL",
  //CONTROL CAMBIOS
  CONTROL_CAMBIOS_AREAS = "CONTROL_CAMBIOS.AREAS",
  CONTROL_CAMBIOS_APROBADORES = "CONTROL_CAMBIOS.APROBADORES",
  CONTROL_CAMBIOS_CAMBIOS = "CONTROL_CAMBIOS.CAMBIOS",
  CONTROL_CAMBIOS_MIS_APROBACIONES = "CONTROL_CAMBIOS.MIS_APROBACIONES",
  CONTROL_CAMBIOS_RESPONSABLES = "CONTROL_CAMBIOS.RESPONSABLES",
  CONTROL_CAMBIOS_MAILS = "CONTROL_CAMBIOS.MAILS",
  CONTROL_CAMBIOS_SERVIDORES = "CONTROL_CAMBIOS.SERVIDORES",
  CONTROL_CAMBIOS_MIS_CAMBIOS = "CONTROL_CAMBIOS.MIS_CAMBIOS",
  CONTROL_CAMBIOS_TIPO_RIESGO = "CONTROL_CAMBIOS.TIPO_RIESGO",
  CONTROL_CAMBIOS_TIPO_ACCION = "CONTROL_CAMBIOS.TIPO_ACCION",
  CONTROL_CAMBIOS_TIPO_METRICA = "CONTROL_CAMBIOS.TIPO_METRICA",
  // // // SOPORTE CORPORATIVO ============================
  SOPORTE_CORPORATIVO_GESTION_TICKETS = 'SOPORTE_CORPORATIVO.GESTION_TICKETS',

  ///* kit
  INVENTARIO_KIT = 'INVENTARIO.KITINVENTARIO',
  ///** marketing
  MARKETING_SOLICITUDES = "MARKETING.SOLICITUD",
  MARKETING_REVISION_SOLICITUDES = "MARKETING.REVISION_SOLICITUDES_EVENTO_CANJE",
  MARKETING_SOLUCION_SOLICITUDES = "MARKETING.SOLUCION_SOLICITUDES_EVENTO_CANJE",

  // // // SOLUCIONES DIGITALES ============================
  SOLUCIONES_DIGITALES_SERVICIOS = "SOLUCIONES_DIGITALES.SERVICIOS",

  // REPORTES SOFTNET
  REPORTES_SOFTNET = "REPORTES.REPORTE_DE_VENTA",
  REPORTES_SOFTNET_VENDEDORES_EXTERNOS_CALL_CENTER = "REPORTES.REPORTES_SOFTNET_VENDEDORES_EXTERNOS_CALL_CENTER",
  REPORTES_SOFTNET_EQUIPOS_SIN_MOVIMIENTO = "REPORTES.REPORTES_SOFTNET_EQUIPOS_SIN_MOVIMIENTO",
  REPORTES_SOFTNET_CONTRATOS_PENDIENTES = "REPORTES.REPORTE_DE_CONTRATOS_PENDIENTES",
  REPORTES_SOFTNET_COMISIONES = "REPORTES.REPORTE_DE_COMISIONES",
  REPORTES_SOFTNET_VALORES = "REPORTES.REPORTE_DE_VALORES",

  MIGRACION = "MIGRACION",
  REPORTES_SOFTNET_CONTRATOS = "REPORTES.REPORTE_DE_CONTRATOS",
  REPORTES_SOFTNET_GOLONDRINAS = "REPORTES.REPORTE_DE_GOLONDRINAS",
  REPORTES_ACTIVIDAD_INVENTARIO = "REPORTES.ACTIVIDAD_INVENTARIO",
}
